import { memo } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

interface WindowControlProps {
  name: string;
  isOpen: boolean;
  onUp: () => void;
  onDown: () => void;
}

const WindowControl = memo<WindowControlProps>(
  ({ name, isOpen, onUp, onDown }) => (
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-1.5 mb-2">
        <p className="text-white/50 text-[13px]">{name}</p>
        <span
          className={`text-[11px] px-1.5 py-0.5 rounded-sm font-[400] ${isOpen ? "bg-[#137FE3]/20 text-[#137FE3]" : "bg-white/[0.06] text-white/50"}`}
        >
          {isOpen ? "Open" : "Closed"}
        </span>
      </div>
      <div className="flex gap-1.5 border-[1px] border-white/[0.07] bg-gradient p-1 rounded-sm">
        <button
          onClick={onUp}
          disabled={isOpen}
          className={`flex-1 py-[10px] flex items-center justify-center
                   border rounded-sm transition-colors active:scale-95
                   ${
                     isOpen
                       ? "bg-[#137FE3]/65 border-[#137FE3]/40 hover:bg-[#137FE3]/85"
                       : "bg-white/[0.05] border-white/[0.08] hover:bg-white/[0.09] disabled:opacity-40"
                   }`}
        >
          <FaChevronUp size={11} className="text-white" />
        </button>
        <button
          onClick={onDown}
          disabled={!isOpen}
          className={`flex-1 py-[10px] flex items-center justify-center
                   border rounded-sm transition-colors active:scale-95
                   ${
                     !isOpen
                       ? "bg-[#137FE3]/65 border-[#137FE3]/40 hover:bg-[#137FE3]/85"
                       : "bg-white/[0.05] border-white/[0.08] hover:bg-white/[0.09] disabled:opacity-40"
                   }`}
        >
          <FaChevronDown size={11} className="text-white/65" />
        </button>
      </div>
    </div>
  ),
);

WindowControl.displayName = "WindowControl";
export default WindowControl;
